import React from 'react';
import MainPanel from '../layout/MainPanel';
import { useLocale } from '../../context/LocaleContext';

const cardStyle = {
  background: '#1f2229',
  borderRadius: 12,
  padding: '18px 20px',
  color: '#f3f4f6',
  border: '1px solid rgba(255,255,255,0.06)',
  marginBottom: 12,
};

export default function NotesMainPanel({ title, subtitle, items, emptyTitle, emptySubtitle }) {
  const { t } = useLocale();
  const list = Array.isArray(items) ? items : [];
  return (
    <MainPanel title={title} subtitle={subtitle}>
      {list.length === 0 ? (
        <div className="custio-empty" style={{ paddingTop: 24 }}>
          <p className="custio-empty__title">{emptyTitle || t('common.nothingYet')}</p>
          <p style={{ fontSize: 14, margin: 0, color: '#9ca3af' }}>{emptySubtitle || t('common.seedHint')}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          {list.map((it) => (
            <div key={it.id} style={cardStyle}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>{it.title}</h3>
              <p style={{ margin: '10px 0 0', fontSize: 14, color: '#9ca3af', whiteSpace: 'pre-wrap' }}>{it.body}</p>
            </div>
          ))}
        </div>
      )}
    </MainPanel>
  );
}
